import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import LeadDetectionSettings from "@/components/LeadDetectionSettings";

export default function LeadSettings() {
  return (
    <div className="p-6 md:p-8 max-w-5xl mx-auto">
      <Link
        to="/app/settings"
        className="inline-flex items-center gap-1 text-[12.5px] text-slate-500 hover:text-slate-900 mb-3"
      >
        <ChevronLeft size={14} /> Settings
      </Link>
      <div className="mb-6">
        <h1 className="text-[32px] font-extrabold tracking-tight text-slate-900 leading-tight">Lead Detection</h1>
        <p className="text-[14px] text-slate-500 mt-1">
          Capture incoming messages as leads and push them to your CRM, Slack, or email.
        </p>
      </div>

      <LeadDetectionSettings />
    </div>
  );
}
